function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 11,
    viewBox: "0 0 28 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2258"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2704",
    d: "M26.568 346.886H1.434A1.452 1.452 0 0 1 0 345.416v-8.06a1.452 1.452 0 0 1 1.433-1.47h25.135a1.451 1.451 0 0 1 1.432 1.47v8.06a1.452 1.452 0 0 1-1.433 1.47",
    transform: "translate(-.001 -335.886)",
    style: {
      fill: "#33a0fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2705",
    d: "m31.691 363.594 1.694-5.928h2.375c-.788 2.457-2.479 7.721-2.5 7.721h-3.14c-.019 0-1.71-5.264-2.5-7.721H30z",
    transform: "translate(-25.542 -356.026)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2706",
    d: "M247.573 357.679H239.7l.594 1.77h2.516v5.951h2.257v-5.95h2.509z",
    transform: "translate(-221.656 -356.038)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2707",
    d: "m181.952 387.446-.24-.524a22.934 22.934 0 0 0-3.283 3.246l-.752-.847-.273.919-.035.134c.286.41 1.071 1.786 1.071 1.786a17.433 17.433 0 0 1 3.512-4.715",
    transform: "translate(-164.016 -382.884)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2708",
    d: "m137.816 359.457.773 2.706c.471-.54 1.093-1.22 1.688-1.779-.491-1.521-.881-2.721-.89-2.721h-3.143c-.019 0-1.71 5.264-2.5 7.721h2.375z",
    transform: "translate(-123.678 -356.024)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2709",
    d: "m205.89 414.6.332 1.12h2.378c-.29-.871-.7-2.106-1.107-3.321a19.945 19.945 0 0 0-1.6 2.2",
    transform: "translate(-190.39 -406.422)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTax);
export default __webpack_public_path__ + "static/media/tax.b46683f9.svg";
export { ForwardRef as ReactComponent };